import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createNumberRange } from "utils";

function BackupPlanDaily(props) {
  function updateDays(arr) {
    let tempPlan = { ...props.planSettings };
    tempPlan.scheduleInfo.type =
      arr.length === 5
        ? props.enums.ScheduleType.CUSTOM
        : props.enums.ScheduleType.DAILY;
    tempPlan.scheduleInfo.weekDays = arr;
    props.setPlanSettings(tempPlan);
  }

  return (
    <React.Fragment>
      <div className="sche_backup_item daily random_schedule">
        <div className="idapp__schedule idapp-daily__schedule">
          <label className="idapp-form__label">Backup start days:</label>
          <div className="idapp-radiogrp-schedule idapp-dailygrp-schedule">
            <div className="idapp-radio__div">
              <label
                className="idapp-radio__label"
                htmlFor="bkp-daily-runeveryday"
              >
                <input
                  className="idapp-radio__input"
                  type="radio"
                  id="bkp-daily-runeveryday"
                  name="bkp-daily-freq"
                  checked={
                    props.planSettings.scheduleInfo.weekDays.length === 7
                  }
                  onChange={() => updateDays(createNumberRange(7, 0))}
                />
                <span className="idapp-radio__checkmark"></span>
                <span className="idapp-radio__name">Run every day</span>
              </label>
            </div>
            <div className="idapp-radio__div">
              <label
                className="idapp-radio__label"
                htmlFor="bkp-daily-runmontofri"
              >
                <input
                  className="idapp-radio__input"
                  type="radio"
                  id="bkp-daily-runmontofri"
                  name="bkp-daily-freq"
                  checked={
                    props.planSettings.scheduleInfo.weekDays.length === 5 &&
                    createNumberRange(5, 1).every(day =>
                      props.planSettings.scheduleInfo.weekDays.includes(day)
                    )
                  }
                  onChange={() => {
                    updateDays(createNumberRange(5, 1));
                  }}
                />
                <span className="idapp-radio__checkmark"></span>
                <span className="idapp-radio__name">Run Monday to Friday</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

function mapStateToProps(state) {
  return {
    enums: state.common.enums
  };
}

export default connect(mapStateToProps)(BackupPlanDaily);
